import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";
import { findIndex } from "lodash";

const mutations = {
  [types.GET_TASKS_BEGIN](state) {
    state.tasksGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_TASKS_SUCCESS](state, tasks) {
    state.tasksGetError = null;
    state.tasks = tasks;
    state.tasksGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_TASKS_ERROR](state, err) {
    state.tasksGetState = API_STATES.REQUEST_ERROR;
    state.tasksGetError = err;
  },
  [types.DELETE_TASK_BEGIN](state) {
    state.taskDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_TASK_SUCCESS](state, id) {
    state.tasksDeleteError = null;
    state.taskDeleteState = API_STATES.REQUEST_SUCCESS;
    const index = findIndex(state.tasks, function(o) {
      return o.id === id;
    });
    state.tasks.splice(index, 1);
  },
  [types.DELETE_TASK_ERROR](state, err) {
    state.taskDeleteState = API_STATES.REQUEST_ERROR;
    state.tasksDeleteError = err;
  },


  //create task
  [types.CREATE_TASK_BEGIN](state) {
    state.taskCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_TASK_SUCCESS](state, data) {
    state.taskCreateError = null
    state.taskCreateState = API_STATES.REQUEST_SUCCESS
    state.task = data
  },
  [types.CREATE_TASK_ERROR](state, err) {
    state.taskCreateState = API_STATES.REQUEST_ERROR;
    state.taskCreateError = err;
  },

  //updata task settings
  [types.UPDATE_TASK_BEGIN](state) {
    state.taskUpdateState =  API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_TASK_SUCCESS](state, data) {
    state.taskUpdateError = null
    state.task = data
    state.taskUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_TASK_ERROR](state, err) {
    state.taskUpdateState = API_STATES.REQUEST_ERROR
    state.taskUpdateError = err
  },
  
  [types.ADD_TASK_POSITION_BEGIN](state, positionId) {
    state.taskPositionUpdating.push(positionId)
  },
  [types.ADD_TASK_POSITION_SUCCESS](state, { data, rootState }) {
    const index = findIndex(state.taskPositionUpdating, data.positionId);
    state.taskPositionUpdating.splice(index, 1);

    rootState.app.formData.taskPositions.push(data)
    state.taskPositionUpdateError = null
  },
  [types.ADD_TASK_POSITION_ERROR](state, { err, positionId }) {
    const index = findIndex(state.taskPositionUpdating, positionId);
    state.taskPositionUpdating.splice(index, 1);
    state.taskPositionUpdateError = err;
  },

  //un-assign task exemption to particular user
  [types.DELETE_TASK_POSITION_BEGIN](state, positionId) {
    state.taskPositionDeleting.push(positionId);
  },
  [types.DELETE_TASK_POSITION_SUCCESS](state, { positionId, rootState }) {
    state.taskPositionDeleteError = null;
    
    const index = findIndex(rootState.app.formData.taskPositions, { positionId });
    rootState.app.formData.taskPositions.splice(index, 1)

    const index2 = findIndex(state.taskPositionDeleting, positionId );
    state.taskPositionDeleting.splice(index2, 1);
  },
  [types.DELETE_TASK_POSITION_ERROR](state, { err, positionId }) {
    const index = findIndex(state.taskPositionDeleting, positionId);
    state.taskPositionDeleting.splice(index, 1);
    state.taskPositionDeleteError = err;
  },

  //assign task exemption to particular user
  [types.ADD_TASK_EXEMPTION_BEGIN](state, exemptionId) {
    state.taskExemptionUpdating.push(exemptionId)
  },
  [types.ADD_TASK_EXEMPTION_SUCCESS](state, { data, rootState }) {
    const index = findIndex(state.taskExemptionUpdating, data.exemptionId);
    state.taskExemptionUpdating.splice(index, 1);

    rootState.app.formData.taskExemptions.push(data)
    state.userDepartmentUpdateError = null
  },
  [types.ADD_TASK_EXEMPTION_ERROR](state, { err, exemptionId }) {
    const index = findIndex(state.taskExemptionUpdating, exemptionId);
    state.taskExemptionUpdating.splice(index, 1);
    state.userDepartmentUpdateError = err;
  },

  //un-assign task exemption to particular user
  [types.DELETE_TASK_EXEMPTION_BEGIN](state, exemptionId) {
    state.taskExemptionDeleting.push(exemptionId);
  },
  [types.DELETE_TASK_EXEMPTION_SUCCESS](state, { exemptionId, rootState }) {
    state.taskExemptionDeleteError = null;
    
    const index = findIndex(rootState.app.formData.taskExemptions, { exemptionId });
    rootState.app.formData.taskExemptions.splice(index, 1)

    const index2 = findIndex(state.taskExemptionDeleting, exemptionId );
    state.taskExemptionDeleting.splice(index2, 1);
  },
  [types.DELETE_TASK_EXEMPTION_ERROR](state, { err, exemptionId }) {
    const index = findIndex(state.taskExemptionDeleting, exemptionId);
    state.taskExemptionDeleting.splice(index, 1);
    state.taskExemptionDeleteError = err;
  },

  //assign task skill to particular user
  [types.ADD_TASK_SKILL_BEGIN](state, skillId) {
    state.taskSkillUpdating.push(skillId)
  },
  [types.ADD_TASK_SKILL_SUCCESS](state, { data, rootState }) {
    const index = findIndex(state.taskSkillUpdating, data.skillId);
    state.taskSkillUpdating.splice(index, 1);

    rootState.app.formData.taskSkills.push(data)
    state.taskSkillUpdateError = null
  },
  [types.ADD_TASK_SKILL_ERROR](state, { err, skillId }) {
    const index = findIndex(state.taskSkillUpdating, skillId);
    state.taskSkillUpdating.splice(index, 1);
    state.taskSkillUpdateError = err;
  },

  //un-assign task exemption to particular user
  [types.DELETE_TASK_SKILL_BEGIN](state, skillId) {
    state.taskSkillDeleting.push(skillId);
  },
  [types.DELETE_TASK_SKILL_SUCCESS](state, { skillId, rootState }) {
    state.taskSkillDeleteError = null;
    
    const index = findIndex(rootState.app.formData.taskSkills, { skillId });
    rootState.app.formData.taskSkills.splice(index, 1)

    const index2 = findIndex(state.taskSkillDeleting, skillId );
    state.taskSkillDeleting.splice(index2, 1);
  },
  [types.DELETE_TASK_SKILL_ERROR](state, { err, skillId }) {
    const index = findIndex(state.taskSkillDeleting, skillId);
    state.taskSkillDeleting.splice(index, 1);
    state.taskSkillDeleteError = err;
  }
};

export default mutations;
